import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { AsapService } from 'asap-crud';

@Component({
    selector: 'app-editor-custom-component-forum-theme-config',
    templateUrl: 'forum-theme-config.component.html',
    providers: [ AsapService ]
})
export class ForumThemeConfigComponent {

    @Input() item: any;
    @Input() customData: any;
    @Output() public sendEvent = new EventEmitter<any>();

    public companies;

    public fields = [];

    constructor(
        public service: AsapService
    ) {

    }

    emitSendEvent() {
        this.sendEvent.emit();
    }

}
